"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentUpload = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Responsive_1 = require("@amzn/atoz-web/Responsive");
const View_1 = require("@amzn/atoz-web/View");
const Col_1 = require("@amzn/atoz-web/Col");
const Text_1 = require("@amzn/atoz-web/Text");
const file_upload_1 = require("@amzn/stencil-react-components/file-upload");
const Theme_1 = require("@amzn/atoz-web/Theme");
const utils_1 = require("../../utils");
const DocumentUpload = ({ title, description, isMulti = true, fileTypes = [], maxSize }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { matches } = (0, Responsive_1.useBreakpoints)();
    const handleUploadFiles = ({ files, setFiles, setFailedFiles, setRequests }) => {
        setFiles(files);
        setFailedFiles([]);
    };
    return (react_1.default.createElement(Col_1.Col, { gridGap: "S200" },
        react_1.default.createElement(Text_1.H4, null, title),
        react_1.default.createElement(View_1.View, { color: "neutral70" },
            fileTypes && (react_1.default.createElement(ItalicText, { fontSize: "T200" }, `${t('time_and_attendance_TSA_DocUpload_FileTypes')}: ${fileTypes.join(', ')}`)),
            maxSize && (react_1.default.createElement(ItalicText, { fontSize: "T200" }, `${t('time_and_attendance_TSA_DocUpload_FileSize')}: ${(0, utils_1.bytesToSize)(maxSize)}`))),
        description && (react_1.default.createElement(Text_1.Text, { color: "neutral70", fontSize: "T200" }, description)),
        react_1.default.createElement(file_upload_1.FileUpload, { dataTestId: "DocumentUpload", accept: fileTypes.join(','), isMulti: isMulti, showDropZone: !matches.s, uploadHandler: handleUploadFiles, onFileAttached: () => null })));
};
exports.DocumentUpload = DocumentUpload;
const ItalicText = (0, Theme_1.styledWithTheme)(Text_1.Text)(`
  font-style: italic;
`);
